import React, { FC } from "react";

import { useInsuranceLabels } from "../../../../Utils/Context/labelsContext";
import { List } from "../../../../Partials/List";
import { CenterContactCard } from "../../../CenterContactCard";

import { GeneralInfoBodyPart } from "./GeneralInfoBodyPart";
import { InsuranceTreaterClinic } from "../../../../../../Pages/InsuranceTreater/InsuranceTreaterClinic.csharp";

interface GeneralInfoBodyClinicsProps {
  clinics: InsuranceTreaterClinic[];
}

export const GeneralInfoBodyClinics: FC<GeneralInfoBodyClinicsProps> = (
  props
) => {
  const { clinics } = props;

  const { headings } = useInsuranceLabels();

  const mapClinicToCards = (clinic: InsuranceTreaterClinic) => (
    <li className="centerContactCard__outer" key={clinic.name}>
      <CenterContactCard {...clinic} />
    </li>
  );

  return (
    <GeneralInfoBodyPart header={headings.clinicsHeading}>
      <List
        items={clinics}
        renderItem={mapClinicToCards}
        useDefaultLayout={false}
        listClassName="generalInfoBodyClinics cardWrapper"
      />
    </GeneralInfoBodyPart>
  );
};
